import { isNotUndefinedOrNull } from '@bizzdesign/sdk-internal';
import { batchQueries, unbatchResults } from './query-batcher';
import { fetch, Response } from 'cross-fetch';

// batchHttpLink creates a batch list of queries that AppSync can't handle
// 1. convert batch query list to single merged query using an alias per item
// 2. execute graphql request (fetch)
// 3. split response with merged query result into batch list

// 4. for each item in the list, map alias back to query key
export async function customFetchMergedQueries(
  input: RequestInfo | URL,
  init?: RequestInit,
): Promise<Response> {
  if (!isNotUndefinedOrNull(init) || !isNotUndefinedOrNull(init.body)) {
    return new Response(
      JSON.stringify({
        errors: [
          {
            message:
              'Invalid request: Missing required request body or initialization parameters',
            code: 'INVALID_REQUEST',
          },
        ],
      }),
      {
        status: 400,
        statusText: 'Bad Request',
      },
    );
  }

  const bodyString = init['body'].toString();
  const { query, variables, aliasMap } = batchQueries(bodyString);
  init.body = JSON.stringify({ query, variables });

  const response = await fetch(input, init);
  const modifiedResults = await unbatchResults(response, aliasMap);

  return new Response(JSON.stringify(modifiedResults), {
    status: response.status,
    statusText: response.statusText,
    headers: response.headers,
  });
}
